import {ComponentClass} from 'react';
import {BasePopupObject, PopupObject} from '@gongxigames/framework/slot/services/TemplateUtils';

export type SystemPopupPopupID = string;

export type SystemPopup<T = any, V = any> = {
    readonly type: T;
    readonly id: SystemPopupPopupID;
    readonly priority?: number;
    readonly view: V;
    readonly data?: any;
};

export type SystemPopupPropsTypes<D> = {
    id: SystemPopupPopupID;
    data: D;
    onClose: (id: string) => void;
};

export type ReactPIXISystemPopup<D = {}> = {
    data: D;
} & SystemPopup<'ReactPIXI', ComponentClass<SystemPopupPropsTypes<D>>>;

export type HTMLSystemPopup = SystemPopup<'HTML', PopupObject | BasePopupObject>;
